import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { NavigationResponse } from 'app/layout/layout.types';
import { FuseVerticalNavigationComponent as FuseVerticalNavigationComponent_1 } from '../../../../../@fuse/components/navigation/vertical/vertical.component';
import { FuseFullscreenComponent } from '../../../../../@fuse/components/fullscreen/fullscreen.component';
import { UserMenuComponent } from '../../../common/user-menu/user-menu.component';
import { LayoutNavigationEntry, VerticalLayoutBaseComponent } from '../vertical-layout-base.component';

@Component({
    selector: 'classic-layout',
    templateUrl: './classic.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FuseVerticalNavigationComponent_1, RouterLink, MatIconButton, MatIcon, FuseFullscreenComponent, UserMenuComponent, RouterOutlet]
})
export class ClassicLayoutComponent extends VerticalLayoutBaseComponent {

    protected navigationChain(navigation: NavigationResponse): LayoutNavigationEntry[] {
        return [
            { roleKey: 'admin', horizontal: navigation.admin, compact: navigation.adminCompact },
            { roleKey: 'customer', horizontal: navigation.customer, compact: navigation.customer },
            { roleKey: 'auditor', horizontal: navigation.auditor, compact: navigation.auditor },
            { roleKey: 'salesRep', horizontal: navigation.salesRep, compact: navigation.salesRepCompact, currentRole: 'Sales Rep' }
        ];
    }
}
